import {trackEvent} from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export function trackHomepageEvent(
  action: string,
  actionCategory: ACTION_CATEGORY = ACTION_CATEGORY.READ
): void {
  trackEvent({
    module: ANALYTICS_MODULE.NAVIGATION,
    actionCategory,
    action: `new_homepage_${action}`,
  });
}
